/**
 * Feather cuts — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_named_haircuts`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const featherCutsPack: ToilePack = {
    slug: 'feather-cuts',
    category: 'beauty',
    name: 'Feather cuts',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'long', label: 'Long feather', subject: 'long hair cut in feathered layers flicking outward'},
        {key: 'medium', label: 'Medium feather', subject: 'shoulder-length feathered layers with a side part'},
        {key: 'short', label: 'Short feather', subject: 'a short feathered cut with volume at the crown'},
    ],
    styles: [
        {key: 'salon', label: 'Salon', style: 'photographed in a bright hair salon by soft broad window daylight from camera-left, a light and open balance with few dark tones', palette: 'warm white walls and teak, the hair the darkest tone', framing: 'three-quarter view at eye level, the salon mirror soft behind'},
        {key: 'festive', label: 'Festive', style: 'dressed for a festival evening in a silk saree, warm evening light from camera-right, a dark balance with light on the face and the edges of the hair', palette: 'saffron and magenta silk, gold jewellery, marigold garlands soft behind', framing: 'eye-level head-and-shoulders, shallow depth of field'},
        {key: 'campus', label: 'Everyday', style: 'outdoors on a college campus in open shade, soft daylight from overhead, a light balance with soft shadow under the brow', palette: 'sandstone and green trees, a plain cotton kurta', framing: 'eye-level head-and-shoulders, the campus soft behind'},
    ],
    directions: ['burgundy hair', 'curtain bangs', 'round face'],
    directionHint: 'try: burgundy hair',
    seo: {
        title: 'Feather Cuts: Long, Medium, Short',
        metaDescription: 'Nine pictures of the feather cut, soft layers that flick outward: long, medium and short feather cuts in a salon, at a festival and on a campus.',
        h1: 'Feather cuts: long, medium, short',
        tagline: 'Nine pictures, three feather cuts, each in a salon, at a festival and on a campus.',
        intro: 'A feather cut has soft layers that flick outward from the head. These pictures show long hair cut in feathered layers, shoulder-length layers with a side part, and a short cut with volume at the crown. Each is seen in a bright salon, dressed for a festival evening in a silk saree, and outdoors on a college campus. You can type a change, such as burgundy hair or curtain bangs, to ask for the cut with it.',
        useCases: [
            'a reference for the outward flick',
            'choosing a long, medium or short feather cut',
            'a print for a salon',
            'a profile picture',
        ],
        faq: [
            {q: 'What does the feathered shape look like?', a: 'The layers are soft and turn outward, so the ends flick away from the face.'},
            {q: 'What is the difference between the three?', a: 'The long cut has feathered layers flicking outward. The medium cut has shoulder-length layers with a side part. The short cut has volume at the crown.'},
            {q: 'Can I change the colour or add bangs?', a: 'Yes. Type the change and the picture is made with it. It is a request, so the result may differ from the sample.'},
        ],
    },
}
